<template>
  <div class="main">
    <!-- 轮播图 -->
    <div class="home-banner"
         :style="{ backgroundImage: 'url(' + (currentProduct && currentProduct.banner_image ? currentProduct.banner_image : require('../assets/images/banner.png')) + ')'}">
    </div>
    <div class="agent">
      <div class="box">
        <div class="u-flex u-row-center tab">
          <div class="item" :class="{ 'active': tabIndex1 === index }" v-for="(item, index) in domesticTabList"
               :key="index" @click="onTab1(index)">{{ item }}
          </div>
        </div>
        <div class="mt50 u-flex u-col-top tab-contnt" v-if="tabIndex1 == 0">
          <div class="combo">
            <!-- 包量套餐 -->
            <h3>包量套餐</h3>
            <el-collapse class="collapse" v-model="activeNames" accordion>
              <el-collapse-item :title="item.validity_minutes + '分钟'" :name="index + 1"
                                v-for="(item, index) in goods_gift_config_num" :key="index">
                <template #title>
                  <div class="u-flex u-row-between custom-title">
                    <span>{{ item.validity_minutes }}分钟</span>
                    <span class="toggle-text">{{ isPanelActive(index + 1) ? '收起' : '展开' }}</span>
                  </div>
                </template>
                <dl class="u-flex u-row-between quantity-item"
                    v-for="(quantityItem, qIndex) in item.goods_gift_config_num" :key="qIndex"
                    :class="{ 'active': giftInfo.num_id ==  quantityItem.id}"
                    @click="onLeftQuantityClick(item,quantityItem)"
                    style="cursor: pointer;">
                  <dt>{{ quantityItem.num + '个' }}</dt>
                  <dd class="bonus-tag">赠送{{ quantityItem.gift }}%</dd>
                </dl>
              </el-collapse-item>
            </el-collapse>

            <!-- 包时套餐 -->
            <h3>包时套餐</h3>
            <div class="collapse">
              <dl class="u-flex u-row-between" v-for="(item, index) in goods_volume_config" :key="index"
                  @click="onLeftTimePackageClick(item.duration_days)" style="cursor: pointer;">
                <dt>{{ item.duration_days }}天</dt>
                <dd>{{ formatDiscountFold(item.discount) }}</dd>
              </dl>
            </div>
          </div>
          <div class="purchase">
            <h3>计费方式</h3>
            <div class="charge">
              <div class="charge-item" :class="{ 'active': goodsInfo.id == item.id }"
                   v-for="(item, index) in chinaIpGoods" :key="index"
                   @click=" goodsInfo = item;initSkuSpec()">
                <h4>{{ item.title }}</h4>
                <p class="description">{{
                    item.description
                  }}</p>
              </div>
            </div>

            <div v-for="(item1,index) in skuSpec">
              <h3 class="mt50">{{ item1.title }}</h3>
              <div class="aging">
                <div class="aging-item" @click="cutSku(item2, index)"
                     :class="goods_sku_ids[index] == item2.id ? 'active': '' "
                     v-for="(item2) in item1.sku_value">
                  <h4>{{ item2.title }}</h4>
                  <!--                  <p class="price">¥{{ item.price }}/IP</p>-->
                </div>
              </div>
            </div>
            <!-- 购买IP总数/每日提取上限 -->
            <h3 class="mt50">{{ goodsInfo.price_type == 1 ? '购买IP总数' : '每日提取上限' }}</h3>
            <div class="total">
              <el-input-number ref="operationScore" class="mt24" v-model="total"
                               @input.native="numChange" :min="0" :max="1000000000000000" :step="1000"
                               label="IP数量">
              </el-input-number>
            </div>
            <h3 class="mt40">产品特性</h3>
            <ul class="mt24 u-flex u-flex-wrap product-features"
                v-if="goodsInfo && goodsInfo.goods_features && goodsInfo.goods_features.length > 0">
              <li v-for="(fe, index) in goodsInfo.goods_features" :key="index">
                <i class="el-icon-check"></i>{{ fe.title }}
              </li>
            </ul>
          </div>
          <div class="order">
            <h3>订单详情</h3>
            <div class="mt30">
              <dl class="u-flex u-row-between">
                <dd>计费方式</dd>
                <dt>{{ getCurrentGoodsPriceType() === 1 ? '包量套餐' : '包时套餐' }}</dt>
              </dl>
              <dl class="u-flex u-row-between">
                <dd>IP时效</dd>
                <dt>{{ selectedIpValidity }}分钟</dt>
              </dl>
              <dl class="u-flex u-row-between" v-if="goodsInfo.price_type === 0 && selectedPackageDuration">
                <dd>套餐时效</dd>
                <dt>{{ selectedPackageDuration }}天</dt>
              </dl>
              <dl class="u-flex u-row-between" v-if="goodsInfo.price_type === 1">
                <dd>购买IP量</dd>
                <dt>{{ total }}IP</dt>
              </dl>

              <dl class="u-flex u-row-between" v-if="goodsInfo.price_type === 0">
                <dd>每日提取上限</dd>
<!--                <dt>{{ dailyIpLimit }}IP</dt>-->
                <dt>{{ total }}IP</dt>
              </dl>

              <dl class="u-flex u-row-between"
                  v-if="goodsInfo.price_type === 1 && selectedIpValidity && totalIpCount > 0">
                <dd>额外赠送IP</dd>
                <dt>{{ bonusIpCount }}IP</dt>
              </dl>
              <dl class="u-flex u-row-between"
                  v-if="goodsInfo.price_type === 1 && selectedIpValidity && total > 0">
                <dd>最终获得IP量</dd>
                <dt>{{ total }} + {{ bonusIpCount }} = {{ finalTotalIpCount }}IP</dt>
              </dl>

              <!-- 显示包量套餐的赠送信息（当选择包时套餐时） -->
              <template
                  v-if="getCurrentGoodsPriceType() === 0 && volumeBasedPackages && volumeBasedPackages.length > 0">
                <dl class="u-flex u-row-between">
                  <dd>包量套餐赠送</dd>
                  <dt>点击左侧包量套餐查看</dt>
                </dl>
              </template>
              <dl class="u-flex u-row-between">
                <dd>原价</dd>
                <dt>¥{{ originalPrice }}</dt>
              </dl>
              <!-- 显示折扣信息（当选择包时套餐且有折扣时） -->
              <dl class="u-flex u-row-between"
                  v-if="goodsInfo.price_type === 0 && shouldApplyDiscount && currentDiscountPercentage > 0">
                <dd>套餐折扣</dd>
                <dt style="color: #ff6b35;">{{  formatDiscountFold(currentDiscountPercentage) }}</dt>
              </dl>
              <!--              <dl class="u-flex u-row-between" v-if="goods">-->
              <!--                <dd>实时价格</dd>-->
              <!--                <dt>¥{{ currentPrice }}</dt>-->
              <!--              </dl>-->
              <dl class="u-flex u-row-between pay">
                <dd>实付价格</dd>
                <dt>¥{{ finalPrice }}</dt>
              </dl>
            </div>
            <div class="payment">
              <div class="payment-item" :class="{ 'active': payType === item.type }" v-for="(item, index) in payList"
                   :key="index" @click="payType = item.type">
                <div class="u-flex pay-type">
                  <img v-if="item.type !== 'alipay'" :src="item.icon" :alt="item.name">
                  <span v-if="item.type === 'alipay'" class="alipay-icon">支</span>
                  <span class="ml10">{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="mt40">
              <el-button class="pay-btn" type="primary" @click="onImmediatePayment">立即支付</el-button>
            </div>
          </div>
        </div>

        <!--        <div class="mt50 u-flex tab-contnt" v-else>-->

        <!--          <div class="u-flex u-col-top u-row-between customize-container">-->

        <!--            <img :src="customizedGoods.image" alt="" class="customize-image">-->
        <!--            <div class="ml36 customize">-->
        <!--              <p>-->
        <!--                {{ customizedGoods.description }}-->
        <!--              </p>-->
        <!--              <ul class="mt30 u-flex">-->
        <!--                <li>优质IP</li>-->
        <!--                <li>企业IP</li>-->
        <!--                <li>精选IP</li>-->
        <!--              </ul>-->
        <!--              <div class="mt30 consultative">-->
        <!--                <el-button type="primary">立即咨询</el-button>-->
        <!--              </div>-->
        <!--              <dl class="mt30 u-flex u-flex-wrap" v-for="(item, index) in customizedGoods.goods_features" :key="index">-->
        <!--                <dt><i class="el-icon-check"></i>{{ item.title }}</dt>-->

        <!--              </dl>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>


    </div>
    <section class="features">
      <div class="box features-box">
        <h2>给你最好的工作流程和体验</h2>
        <p>值得信赖的专业化代理平台，提高效率，降低成本，您的私人专属代理</p>
        <div class="feature-cards"
             v-if="currentProduct && currentProduct.goods_service && currentProduct.goods_service.length > 0">
          <div class="feature-card" v-for="(feature, index) in currentProduct.goods_service" :key="index">
            <img :src="feature.image || require('../assets/images/gmdl_icon' + (index + 1) + '.png')"
                 :alt="feature.title">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
        <!-- 默认特性卡片，当没有商品服务时显示 -->
        <div class="feature-cards" v-else>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon6.png" alt="每日30万高匿IP">
            <h3>每日30万高匿IP</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon5.png" alt="单次提取数量自定义">
            <h3>单次提取数量自定义</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon1.png" alt="延迟小于100毫秒">
            <h3>延迟小于100毫秒</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon3.png" alt="日提取数量不限">
            <h3>日提取数量不限</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon2.png" alt="可拓展API接口">
            <h3>可拓展API接口</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon4.png" alt="7X24小时技术服务支持">
            <h3>7X24小时技术服务支持</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 微信支付弹窗 -->
    <el-dialog title="微信支付" :visible.sync="showWechatDialog" width="400px" center :close-on-click-modal="false"
               custom-class="wechat-pay-dialog" :width="dialogWidth">
      <div style="text-align: center;">
        <h3>微信扫码支付</h3>
        <div style="margin: 20px 0;">
          <img :src="wechatQrCode" alt="微信支付二维码"
               style="max-width: 200px; height: auto; border: 1px solid #eee; border-radius: 4px;">
        </div>
        <p>请使用微信扫描二维码完成支付</p>
        <p style="color: #ff6b35; font-weight: bold;">支付金额：¥{{ finalPrice }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showWechatDialog = false">取消</el-button>

        <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
      </div>
    </el-dialog>

    <!-- 支付宝支付弹窗 -->
    <el-dialog title="支付宝支付" :visible.sync="showAlipayDialog" width="400px" center :close-on-click-modal="false"
               custom-class="alipay-pay-dialog" :width="dialogWidth">
      <div style="text-align: center;">
        <div style="margin: 20px 0;">
          <div style="margin: 20px 0;">
            <img src="../assets/images/gmdl_zhifubao.png"/>
          </div>
        </div>
        <p>请点击下方按钮跳转到支付宝完成支付</p>
        <p style="color: #ff6b35; font-weight: bold;">支付金额：¥{{ finalPrice }}</p>
        <p style="color: #999; font-size: 12px; margin-top: 10px;">支付完成后请返回页面查看订单状态</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAlipayDialog = false">取消</el-button>
        <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
        <el-button type="primary" @click="goToAlipayPay">去支付</el-button>
      </div>
    </el-dialog>

    <!-- 余额支付弹窗 -->
    <el-dialog title="余额支付" :visible.sync="showBalanceDialog" width="400px" center :close-on-click-modal="false"
               custom-class="balance-pay-dialog" :width="dialogWidth">
      <div style="text-align: center;">
        <div style="margin: 20px 0;">
          <div style="margin: 20px 0;">
            <img src="../assets/images/balance.png"/>
          </div>
        </div>
        <p style="color: #ff6b35; font-weight: bold;">支付金额：¥{{ finalPrice }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showBalanceDialog = false">取消</el-button>
        <el-button type="primary" @click="onOrderPay" :loading="payLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>


</template>
<script>
export default {
  name: 'Index',
  data() {
    return {
      order_sn: '',
      goodsList: [],
      customizedGoods: {},
      currentProduct: {
        goods_features: [],
        goods_service: []
      },
      selectedPackage: null,
      selectedProductId: null,
      selectedBillingMethod: null,
      selectedIpValidity: 3,
      selectedPackageDuration: 7,

      totalIpCount: 0, // 初始值为0，会根据规格动态设置
      actualIpCount: 0, // 初始值为0，会根据购买数量动态计算
      dailyIpLimit: 0, // 每日提取上限，初始值为0，会根据规格动态设置
      timeBasedPackages: [],
      sessionPackages: [],
      volumeBasedPackages: [],
      price_type: 0,
      tabIndex1: 0,
      domesticTabList: ["短效动态套餐", "定制套餐"],
      activeNames: [],
      payType: 'balance',
      payList: [
        {name: '余额', icon: require('../assets/images/balance.png'), type: 'balance'},
        {name: '支付宝', icon: require('../assets/images/gmdl_zhifubao.png'), type: 'alipay'},
        // {name: '微信', icon: require('../assets/images/gmdl_weixin.png'), type: 'wechat'},

      ],

      // 微信支付相关
      showWechatDialog: false,
      wechatPayData: null,
      wechatQrCode: '',

      // 支付宝支付相关
      showAlipayDialog: false,
      alipayPayData: null,

      // 余额支付相关
      showBalanceDialog: false,
      balancePayData: null,

      productsList: [],
      sku_ind: 0,
      payLoading: false,
      chinaIpGoods: [],
      goods: {},
      goodsInfo: {
        goods_features: [],
        goods_service: [],
        sku: [],
        sku_spec: []
      },
      skuSpec: [],
      goods_sku_ids: [],
      goods_sku_text: [],
      limitation_ip: 0,
      total: 0,
      goods_gift_config_num: [], // 赠送
      goods_volume_config: [], // 折扣
      giftInfo: {
        minute_id: 0,
        num_id: 0,
      },
      volume_id: 0,//赠送选择的id
      userSelectedQuantity: false, // 用户是否主动选择了数量

    }
  },
  computed: {
    // 响应式弹窗宽度
    dialogWidth() {
      if (typeof window !== 'undefined') {
        return window.innerWidth <= 768 ? '90%' : '400px';
      }
      return '400px';
    },

    // IP时效选项
    ipValidityOptions() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods) return [];

      // 从sku中获取所有唯一的validity_minutes，因为sku_spec中没有validity_minutes字段
      if (goods.sku && goods.sku.length > 0) {
        const uniqueValidities = [...new Set(goods.sku.map(sku => sku.validity_minutes))];

        return uniqueValidities.map(validity => {
          // 从sku中查找对应的价格信息
          const sku = goods.sku.find(sku => sku.validity_minutes === validity);
          return {
            validity_minutes: validity,
            price: sku && sku.ip_price ? sku.ip_price : "0.00"
          };
        });
      }

      return [];
    },

    // 套餐时效选项
    packageDurationOptions() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods || goods.price_type !== 0) return [];

      // 包时套餐 (price_type = 0)
      if (goods.sku) {
        const uniqueDurations = [...new Set(goods.sku.map(sku => sku.duration_days))];
        return uniqueDurations.map(duration => {
          const sku = goods.sku.find(sku => sku.duration_days === duration);
          return {
            duration_days: duration,
            discount_percentage: "0.00", // 可以根据需要调整
            original_price: sku && sku.price ? sku.price : "0.00"
          };
        });
      }
      return [];
    },

    // 获取当前规格的最小IP数量限制
    currentMinIpCount() {
      return 200
      // 从当前选中的规格中获取limitation_ip
      if (this.goods && this.goods.limitation_ip) {
        return this.goods.limitation_ip;
      }

      // 如果是包量套餐，根据IP时效获取limitation_ip
      if (this.goodsInfo.price_type === 1 && this.selectedIpValidity) {
        const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
        if (goods && goods.sku) {
          const sku = goods.sku.find(sku => sku.validity_minutes === this.selectedIpValidity);
          if (sku && sku.limitation_ip) {
            return sku.limitation_ip;
          }
        }
      }

      // 如果goods中没有，则从limitation_ip变量获取
      return this.limitation_ip || 1000;
    },

    // 获取包时套餐的最小每日提取上限
    currentMinDailyLimit() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods || goods.price_type !== 0) return 1000; // 只有包时套餐才有每日提取上限

      if (this.selectedIpValidity && this.selectedPackageDuration) {
        if (goods.sku) {
          const sku = goods.sku.find(sku =>
              sku.validity_minutes === this.selectedIpValidity &&
              sku.duration_days === this.selectedPackageDuration
          );
          if (sku && sku.limitation_ip) {
            return sku.limitation_ip;
          }
        }
      }
      return 1000; // 默认最小值
    },

    // 判断是否应该打折（套餐时效和包时套餐选中一样的天数）
    shouldApplyDiscount() {
      if (this.goodsInfo.price_type !== 0) return false; // 只有包时套餐才有折扣

      if (this.selectedPackageDuration && this.goods_volume_config) {
        // 检查是否有对应的折扣配置
        const discountConfig = this.goods_volume_config.find(config =>
            config.duration_days === this.selectedPackageDuration
        );
        return discountConfig && discountConfig.discount > 0;
      }
      return false;
    },

    // 获取当前折扣百分比
    currentDiscountPercentage() {
      if (this.shouldApplyDiscount && this.goods_volume_config) {
        const discountConfig = this.goods_volume_config.find(config =>
            config.duration_days === this.selectedPackageDuration
        );
        return discountConfig ? discountConfig.discount : 0;
      }
      return 0;
    },

    // 计算额外赠送的IP数量
    bonusIpCount() {
      if (this.goodsInfo.price_type !== 1 || !this.selectedIpValidity || !this.total) {
        return 0;
      }

      // 根据当前IP时效和购买数量计算赠送百分比
      const bonusPercentage = this.calculateBonusPercentage(this.total);
      if (bonusPercentage <= 0) {
        return 0;
      }

      // 计算额外赠送的数量（基于购买数量计算）
      const bonusCount = Math.floor(this.total * (bonusPercentage / 100));

      return bonusCount;
    },

    // 计算最终获得的IP数量
    finalTotalIpCount() {
      if (this.goodsInfo.price_type !== 1 || !this.selectedIpValidity || !this.total) {
        return this.total || 0;
      }

      const bonusCount = this.bonusIpCount;
      const totalCount = this.total + bonusCount;

      return totalCount;
    },

    // 计算原价
    originalPrice() {
      if (!this.goods) {
        return '0.00';
      }

      const specPrice = parseFloat(this.goods.price || 0);
      const ipPrice = parseFloat(this.goods.ip_price || 0);
      const defaultIpCount = this.goods.limitation_ip || 0;

      // 无论是包量套餐还是包时套餐，都使用total计算
      const extraIpCount = Math.max(0, this.total - defaultIpCount);
      const extraPrice = extraIpCount * ipPrice;
      const totalPrice = specPrice + extraPrice;

      return totalPrice.toFixed(2);
    },

    // 计算实时价格（打折后的价格）
    currentPrice() {
      if (!this.goods) {
        return '0.00';
      }

      const specPrice = parseFloat(this.goods.price || 0);
      const ipPrice = parseFloat(this.goods.ip_price || 0);
      const defaultIpCount = this.goods.limitation_ip || 0;

      // 无论是包量套餐还是包时套餐，都使用total计算
      const extraIpCount = Math.max(0, this.total - defaultIpCount);
      const extraPrice = extraIpCount * ipPrice;
      let totalPrice = specPrice + extraPrice;

      // 如果是包时套餐且有折扣，在总价格基础上进行打折
      if (this.goodsInfo.price_type === 0 && this.shouldApplyDiscount) {
        const discountPercentage = this.currentDiscountPercentage;
        const discountMultiplier = 1 - (discountPercentage / 100);
        totalPrice = totalPrice * discountMultiplier;
      }

      return totalPrice.toFixed(2);
    },

    // 计算最终价格
    finalPrice() {
      return this.currentPrice;
    },

  },


  watch: {
    goods_sku_ids: {
      handler(val) {
        if (val.length == this.skuSpec.length) {
          const sortedIds = JSON.parse(JSON.stringify(val)).sort();
          this.goods = this.sku[sortedIds] || {};
          this.limitation_ip = this.goods.limitation_ip ? this.goods.limitation_ip : 0

          // 在包量套餐中，如果用户刚选择了数量，不要立即重置
          if (this.goodsInfo.price_type === 1 && this.userSelectedQuantity) {
            // 延迟重置标志，避免下次规格变化时被覆盖
            this.$nextTick(() => {
              this.userSelectedQuantity = false
            })
          } else {
            this.total = this.limitation_ip
          }
          // 规格选择完成后，计算价格
          this.$nextTick(() => {
            this.calculatePrice();
          });
        } else {
          this.gift_config_id = ''
          this.gift_config_num_id = ''
          this.volume_config_id = ''
        }
      },
      deep: true
    },
    // total: {
    //   handler(newVal) {
    //     if (this.goods) {
    //       this.$nextTick(() => {
    //         this.calculatePrice();
    //       });
    //     }
    //   }
    // },
    // totalIpCount: {
    //   handler(newVal) {
    //     if (this.goods) {
    //       // 重新计算赠送信息
    //       this.calculateBonusForCurrentSelection();
    //       this.$nextTick(() => {
    //         this.calculatePrice();
    //       });
    //     }
    //   }
    // },
    // dailyIpLimit: {
    //   handler(newVal) {
    //     if (this.goods) {
    //       this.$nextTick(() => {
    //         this.calculatePrice();
    //       });
    //     }
    //   }
    // },
    // 监听路由参数变化
    '$route.query.tabIndex1': {
      handler(newVal) {
        const tabIndex1 = newVal ? parseInt(newVal) : 0;
        if (tabIndex1 === 1) {
          this.onTab1(1);
        } else {
          this.onTab1(0);
        }
      },
      immediate: true
    },


  },
  created() {
    this.getProductsData()

    // 确保在组件创建时就有默认选择
    this.$nextTick(() => {
      if (this.productsList && this.productsList.length > 0 && !this.selectedBillingMethod) {
        const firstProduct = this.productsList[0];
        this.setCurrentProduct(firstProduct);
        this.selectedBillingMethod = firstProduct.service_type;
        this.selectedProductId = firstProduct.id;
      }
    });
  },

  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);

    // 延迟检查，确保数据加载完成后有默认选择
    setTimeout(() => {
      if (this.productsList && this.productsList.length > 0 && !this.selectedBillingMethod) {
        const firstProduct = this.productsList[0];
        this.setCurrentProduct(firstProduct);
        this.selectedBillingMethod = firstProduct.service_type;
        this.selectedProductId = firstProduct.id;
      }
    }, 1000);
  },

  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },


  methods: {
    // 将折扣百分数（如80）转换为“几折”（如2折）。80%表示优惠80%，即付20%，所以是2折
    formatDiscountFold(discountPercentage) {
      const d = Number(discountPercentage) || 0
      if (d >= 100) {
        return '免费'
      }
      const fold = (100 - d) / 10
      if (fold <= 0) {
        return '10折'
      }
      const foldStr = Number.isInteger(fold) ? String(fold) : fold.toFixed(1).replace(/\.0$/, '')
      return `${foldStr}折`
    },
    numChange() {
      this.total = this.$refs.operationScore.displayValue
      this.calculatePrice();
    },
    // 处理窗口大小变化
    handleResize() {
      // 触发计算属性重新计算
      this.$forceUpdate();
    },

    cutSku(item, index) {
      if (this.goods_sku_ids[index] != undefined && this.goods_sku_ids[index] == item.id) {
        this.$set(this.goods_sku_ids, index, ''); //储存id
        this.$set(this.goods_sku_text, index, '');
      } else {
        this.$set(this.goods_sku_ids, index, item.id); //储存id
        this.$set(this.goods_sku_text, index, item.title); //储存名称
      }

      this.changeItems();

      // 当规格选择变化时，根据套餐类型自动更新选择
      if (this.goodsInfo.price_type == 1) {
        // 包量套餐：自动更新包量套餐的选择
        this.updateVolumePackageSelection();
      } else if (this.goodsInfo.price_type == 0) {
        // 包时套餐：自动更新包时套餐的选择
        this.updateTimePackageSelection();
      }

    },

    changeItems() {

      if (!this.skuSpec || this.skuSpec.length === 0) {
        return;
      }
      let result = []; //定义数组存储被选中的值
      this.skuSpec.forEach((item, index) => {
        result[index] = this.goods_sku_ids[index] ? this.goods_sku_ids[index] : '';
      });
    },
    initSkuSpec() {
      if (!this.goodsInfo || !this.goodsInfo.sku_spec) {
        return;
      }

      // 初始化规格选择
      this.initSkuSelection();

      this.skuSpec = this.goodsInfo.sku_spec;
      let skus = [];
      if (this.goodsInfo.sku && this.goodsInfo.sku.length > 0) {
        this.goodsInfo.sku.forEach(item => {
          let ids = item.sku_id.split(',').sort();
          skus[ids] = item;
        });
      }
      this.sku = skus;
      this.changeItems();

      // 根据套餐类型初始化默认选择
      if (this.goodsInfo.price_type == 1) {
        // 包量套餐：初始化默认的包量套餐选择
        this.initDefaultVolumePackageSelection();
      } else if (this.goodsInfo.price_type == 0) {
        // 包时套餐：初始化默认的包时套餐选择
        this.initDefaultTimePackageSelection();
      }
    },
    getProductsData() {
      this.$api.goods.getChinaIpGoods().then(res => {
        if (res.data.length > 0) {
          this.chinaIpGoods = res.data
          this.goodsInfo = this.chinaIpGoods[0]
          this.initSkuSpec()

          for (const re of this.chinaIpGoods) {
            if (re.price_type == 0) {
              this.goods_volume_config = re.goods_volume_config
            }
            if (re.price_type == 1) {
              this.goods_gift_config_num = re.goods_gift_config
            }
          }

        }
      })


    },

    // 获取当前商品的price_type
    getCurrentGoodsPriceType() {
      if (this.currentProduct) {
        const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
        return goods ? goods.price_type : null;
      }
      return null;
    },

    getGoodsList() {
      this.$api.goods.getChinaIpGoods().then(res => {
        this.goodsList = res.data
        // 处理商品数据
        this.processGoodsData();
      })
    },

    // 处理商品数据
    processGoodsData() {
      if (!this.goodsList || this.goodsList.length === 0) {
        return;
      }

      // 清空之前的数据
      this.productsList = [];
      this.volumeBasedPackages = [];
      this.timeBasedPackages = [];
      this.sessionPackages = [];

      this.goodsList.forEach(goods => {
        // 根据 price_type 来判断商品类型
        if (goods.price_type === 1) {
          // 包量套餐 (price_type = 1)
          this.processVolumeBasedGoods(goods);
        } else if (goods.price_type === 0) {
          // 包时套餐 (price_type = 0)
          this.processTimeBasedGoods(goods);
        }
      });

      // 初始化产品数据
      this.initProductData();
    },

    // 处理包时套餐数据
    processTimeBasedGoods(goods) {
      const timeBasedProduct = {
        id: goods.id,
        product_name: goods.title,
        service_type: goods.price_type === 0 ? 'time_based' : 'volume_based',
        description: goods.description,
        goods_features: goods.goods_features || [], // 添加商品特性
        goods_service: goods.goods_service || [], // 添加商品服务
        time_packages: [],
        session_packages: []
      };

      // 处理套餐时效配置 (goods_volume_config)
      if (goods.goods_volume_config && goods.goods_volume_config.length > 0) {
        goods.goods_volume_config.forEach(config => {
          timeBasedProduct.time_packages.push({
            id: config.id,
            product_id: goods.id,
            package_name: `${config.duration_days}天套餐`,
            duration_days: config.duration_days,
            discount_percentage: config.discount,
            goods_service: goods.goods_service || [], // 添加商品服务
            original_price: "100.00", // 可以根据需要调整
            daily_limit: 2000,
            sort: 0,
            createtime: Date.now(),
            updatetime: Date.now()
          });
        });
      }

      // 处理会话套餐 (sku 数据)
      if (goods.sku && goods.sku.length > 0) {
        // 获取唯一的 validity_minutes
        const uniqueValidities = [...new Set(goods.sku.map(sku => sku.validity_minutes))];

        uniqueValidities.forEach((validity, index) => {
          timeBasedProduct.session_packages.push({
            id: index + 1,
            product_id: goods.id,
            validity_minutes: validity,
            price: (() => {
              const sku = goods.sku.find(sku => sku.validity_minutes === validity);
              return sku && sku.ip_price ? sku.ip_price : "0.00";
            })(),
            sort: index,
            createtime: Date.now(),
            updatetime: Date.now()
          });
        });
      }

      this.productsList.push(timeBasedProduct);
      this.timeBasedPackages = timeBasedProduct.time_packages;
      this.sessionPackages = timeBasedProduct.session_packages;
    },

    // 处理包量套餐数据
    processVolumeBasedGoods(goods) {
      const volumeBasedProduct = {
        id: goods.id,
        product_name: goods.title,
        service_type: goods.price_type === 1 ? 'volume_based' : 'time_based',
        description: goods.description,
        goods_features: goods.goods_features || [], // 添加商品特性
        goods_service: goods.goods_service || [], // 添加商品服务
        volume_based: []
      };

      // 处理赠送配置 (goods_gift_config)
      if (goods.goods_gift_config && goods.goods_gift_config.length > 0) {
        goods.goods_gift_config.forEach(giftConfig => {
          const volumeBasedPackage = {
            id: giftConfig.id,
            product_id: goods.id,
            package_name: `${giftConfig.validity_minutes}分钟包量套餐`,
            validity_minutes: giftConfig.validity_minutes,
            base_price: (() => {
              const sku = goods.sku.find(sku => sku.validity_minutes === giftConfig.validity_minutes);
              return sku && sku.ip_price ? sku.ip_price : "0.0050";
            })(),
            quantity_options: [],
            sort: giftConfig.id,
            createtime: giftConfig.createtime,
            updatetime: giftConfig.updatetime
          };

          // 处理数量配置 (goods_gift_config_num)
          if (giftConfig.goods_gift_config_num && giftConfig.goods_gift_config_num.length > 0) {
            giftConfig.goods_gift_config_num.forEach(numConfig => {
              volumeBasedPackage.quantity_options.push({
                quantity: numConfig.num,
                bonus_percentage: numConfig.gift
              });
            });
          }

          volumeBasedProduct.volume_based.push(volumeBasedPackage);
        });
      }

      // 如果没有赠送配置，从SKU中获取所有IP时效
      if (!goods.goods_gift_config || goods.goods_gift_config.length === 0) {
        if (goods.sku && goods.sku.length > 0) {
          const uniqueValidities = [...new Set(goods.sku.map(sku => sku.validity_minutes))];
          uniqueValidities.forEach((validity, index) => {
            const volumeBasedPackage = {
              id: index + 1,
              product_id: goods.id,
              package_name: `${validity}分钟包量套餐`,
              validity_minutes: validity,
              base_price: (() => {
                const sku = goods.sku.find(sku => sku.validity_minutes === validity);
                return sku && sku.ip_price ? sku.ip_price : "0.0050";
              })(),
              quantity_options: [],
              sort: index,
              createtime: Date.now(),
              updatetime: Date.now()
            };
            volumeBasedProduct.volume_based.push(volumeBasedPackage);
          });
        }
      }

      this.productsList.push(volumeBasedProduct);
      this.volumeBasedPackages = volumeBasedProduct.volume_based;
    },


    onTab1(index) {
      this.tabIndex1 = index

      // 当切换到定制套餐时调用getCustomizedGoods方法
      if (index === 1) {
        this.getCustomizedGoods();
      } else {
        // 切换回普通套餐时，重新设置currentProduct为第一个产品
        if (this.productsList && this.productsList.length > 0) {
          const firstProduct = this.productsList[0];
          this.setCurrentProduct(firstProduct);
          this.selectedBillingMethod = firstProduct.service_type;
          this.selectedProductId = firstProduct.id;
        }
      }
    },

    // 获取定制套餐数据
    getCustomizedGoods() {
      this.$api.goods.getCustomizedGoods().then(res => {
        this.customizedGoods = res.data;

        // 将定制套餐数据设置为currentProduct，以便banner和goods_service能正确显示
        if (res.data) {
          this.currentProduct = {
            id: res.data.id || 'customized',
            product_name: res.data.title || '定制套餐',
            banner_image: res.data.banner_image,
            goods_service: res.data.goods_service || [],
            goods_features: res.data.goods_features || [],
            description: res.data.description
          };
        }

      })
    },

    onToggle(index) {
      this.rateIndex = index
      // if(this.tabIndex === index){

      // }
    },
    // 判断面板是否处于展开状态
    isPanelActive(name) {
      return this.activeNames == name
    },


    // 设置当前产品
    setCurrentProduct(product) {
      this.currentProduct = product;
      this.selectedPackage = null;
      this.selectedBillingMethod = product.service_type;

      // 初始化所有规格选择
      this.initSkuSelection();

      // 根据price_type设置默认值
      const goods = this.goodsList.find(item => item.id === product.id);
      if (goods) {
        if (goods.price_type === 1) {
          // 包量套餐，设置默认IP时效和IP数量
          if (product.volume_based && product.volume_based.length > 0) {
            this.selectedIpValidity = product.volume_based[0].validity_minutes;

            // 设置默认IP数量为规格中的limitation_ip
            this.setDefaultIpCount();
          }
        } else if (goods.price_type === 0) {
          // 包时套餐，设置默认的每日提取上限
          this.setDefaultDailyLimit();
        }
      }

      this.updateSelectedPackage();
    },

    // 初始化产品数据
    initProductData() {
      if (this.productsList && this.productsList.length > 0) {
        // 默认选择第一个产品
        const firstProduct = this.productsList[0];
        if (firstProduct) {
          this.setCurrentProduct(firstProduct);
          this.selectedBillingMethod = firstProduct.service_type;
          this.selectedProductId = firstProduct.id;

          // 根据产品类型设置默认值
          const goods = this.goodsList.find(item => item.id === firstProduct.id);
          if (goods) {
            if (goods.price_type === 1) {
              // 包量套餐，设置默认IP数量
              this.setDefaultIpCount();
            } else if (goods.price_type === 0) {
              // 包时套餐，设置默认的每日提取上限
              this.setDefaultDailyLimit();
            }
          }
        }

        // 初始化包时套餐和会话套餐数据
        this.initPackageData();

        // 预设置包时套餐的默认每日提取上限（当用户切换到包时套餐时使用）
        const timeBasedProduct = this.productsList.find(item => {
          const goods = this.goodsList.find(g => g.id === item.id);
          return goods && goods.price_type === 0;
        });
        if (timeBasedProduct) {
          // 临时设置包时套餐，获取默认值
          const originalBillingMethod = this.selectedBillingMethod;
          const originalProduct = this.currentProduct;

          this.selectedBillingMethod = 'time_based';
          this.currentProduct = timeBasedProduct;

          // 设置默认的IP时效和套餐时效
          if (timeBasedProduct.session_packages && timeBasedProduct.session_packages.length > 0) {
            this.selectedIpValidity = timeBasedProduct.session_packages[0].validity_minutes;
          }
          if (timeBasedProduct.time_packages && timeBasedProduct.time_packages.length > 0) {
            this.selectedPackageDuration = timeBasedProduct.time_packages[0].duration_days;
          }

          // 设置默认的每日提取上限
          this.setDefaultDailyLimit();

          // 恢复原来的选择
          this.selectedBillingMethod = originalBillingMethod;
          this.currentProduct = originalProduct;
        }
      }
    },


    // 初始化套餐数据
    initPackageData() {
      // 处理包时套餐的折扣信息
      this.processTimeBasedDiscounts();
    },

    // 处理包时套餐的折扣信息
    processTimeBasedDiscounts() {
      // 找到包时套餐的商品 (price_type = 0)
      const timeBasedGoods = this.goodsList.find(item => item.price_type === 0);
      if (timeBasedGoods && timeBasedGoods.goods_volume_config) {
        // 更新 timeBasedPackages 的折扣信息
        this.timeBasedPackages = this.timeBasedPackages.map(pkg => {
          const config = timeBasedGoods.goods_volume_config.find(config =>
              config.duration_days === pkg.duration_days
          );
          if (config) {
            return {
              ...pkg,
              discount_percentage: config.discount
            };
          }
          return pkg;
        });
      }
    },


    onLeftQuantityClick(minute, num) {
      // 只有在包量套餐时才执行数量变化逻辑
      if (this.goodsInfo.price_type != 1) {
        return;
      }

      this.giftInfo.minute_id = minute.id
      this.giftInfo.num_id = num.id

      // 设置IP数量
      this.total = num.num
      this.totalIpCount = num.num

      // 标记用户主动选择了数量
      this.userSelectedQuantity = true

      // 设置IP时效
      this.selectedIpValidity = minute.validity_minutes

      // 自动选择对应的规格选项
      this.goodsInfo.sku.forEach((item) => {
        if (item.validity_minutes == minute.validity_minutes) {
          // 根据SKU ID自动选择对应的规格
          if (this.skuSpec && this.skuSpec.length > 0) {
            // 清空之前的规格选择
            this.goods_sku_ids = []
            this.goods_sku_text = []

            // 根据SKU ID找到对应的规格索引并设置选中状态
            const skuIdArray = item.sku_id.split(',').map(id => parseInt(id.trim()))

            this.skuSpec.forEach((spec, specIndex) => {
              spec.sku_value.forEach((value) => {
                if (skuIdArray.includes(value.id)) {
                  this.$set(this.goods_sku_ids, specIndex, value.id)
                  this.$set(this.goods_sku_text, specIndex, value.title)
                }
              })
            })
          }
        }
      })

      // 重新计算赠送信息
      this.calculateBonusForCurrentSelection();

      // 计算价格
      this.$nextTick(() => {
        this.calculatePrice();
      });
    },
    onLeftTimePackageClick(id) {
      this.volume_id = id
      // 只有在包时套餐时才自动选择对应的规格选项
      if (this.goodsInfo.price_type == 0) {
        // 设置套餐时效
        this.selectedPackageDuration = id

        // 自动选择对应的规格选项
        this.goodsInfo.sku.forEach((item) => {
          if (item.duration_days == id) {
            // 根据SKU ID自动选择对应的规格
            if (this.skuSpec && this.skuSpec.length > 0) {
              // 清空之前的规格选择
              this.goods_sku_ids = []
              this.goods_sku_text = []

              // 根据SKU ID找到对应的规格索引并设置选中状态
              const skuIdArray = item.sku_id.split(',').map(id => parseInt(id.trim()))

              this.skuSpec.forEach((spec, specIndex) => {
                spec.sku_value.forEach((value) => {
                  if (skuIdArray.includes(value.id)) {
                    this.$set(this.goods_sku_ids, specIndex, value.id)
                    this.$set(this.goods_sku_text, specIndex, value.title)
                  }
                })
              })

              // 设置IP时效
              if (item.validity_minutes) {
                this.selectedIpValidity = item.validity_minutes
              }

              // 设置每日提取上限
              if (item.limitation_ip) {
                this.dailyIpLimit = item.limitation_ip
                this.total = item.limitation_ip
              }
            }
          }
        })

        // 触发规格变化处理
        this.changeItems()

        // 计算价格
        this.$nextTick(() => {
          this.calculatePrice();
        });
      }
    },

    // 立即支付方法
    onImmediatePayment() {


      // 验证必填参数
      if (!this.validatePaymentParams()) {
        return;
      }

      // 构建支付参数
      const paymentParams = this.buildPaymentParams();
      if(paymentParams.ip_count < this.limitation_ip){
        return  this.$message.error(`当前套餐购买IP数量不能小于${this.limitation_ip}`)
      }
      this.$api.order.createOrder(paymentParams).then(res => {
        this.order_sn = ''
        this.order_sn = res.data.orderInfo.order_sn
        if (this.payType == 'balance') {
          // 余额支付，显示弹窗
          this.showBalanceDialog = true
        } else if (this.payType == 'wechat') {
          this.onOrderPay()
        } else if (this.payType == 'alipay') {
          // 支付宝支付，显示弹窗
          this.onOrderPay()
        }
      });
    },
    onOrderPay() {
      this.payLoading = true
      this.$api.order.orderPay({paytype: this.payType, order_sn: this.order_sn}).then(res => {
        if (res.data.paytype == 'balance') {
          this.$message.success('支付成功');
          this.showBalanceDialog = false
        } else if (res.data.paytype == 'wechat') {

          this.showWechatPayDialog(res.data);
        } else if (res.data.paytype == 'alipay') {
          this.showAlipayPayDialog(res.data);
        }
      }).finally(() => {
        this.payLoading = false
      })

    },

    // 验证支付参数
    validatePaymentParams() {
      // 验证商品信息
      if (!this.goods || !this.goodsInfo) {
        this.$message.error('请选择商品');
        return false;
      }

      // 验证支付方式
      if (!this.payType) {
        this.$message.error('请选择支付方式');
        return false;
      }

      return true;
    },

    // 构建支付参数
    buildPaymentParams() {
      const priceType = this.goodsInfo.price_type;

      // 获取包量套餐赠送ID
      let giftConfigId = null;
      let giftConfigNumId = null;
      if (priceType === 1 && this.selectedIpValidity && this.total > 0) {
        // 检查是否有赠送
        const bonusPercentage = this.calculateBonusPercentage(this.total);
        if (bonusPercentage > 0) {
          // 根据购买数量获取对应的赠送配置ID
          if (this.goodsInfo.goods_gift_config) {
            // 找到对应IP时效的赠送配置
            const giftConfig = this.goodsInfo.goods_gift_config.find(config =>
                config.validity_minutes === this.selectedIpValidity
            );
            if (giftConfig) {
              // 设置gift_config_id为goods_gift_config的ID
              giftConfigId = giftConfig.id;

              // 找到对应数量的配置
              if (giftConfig.goods_gift_config_num) {
                // 按数量从小到大排序
                const sortedConfigs = giftConfig.goods_gift_config_num.sort((a, b) => a.num - b.num);

                // 找到最后一个小于等于当前数量的配置
                let numConfig = null;
                for (let i = sortedConfigs.length - 1; i >= 0; i--) {
                  if (sortedConfigs[i].num <= this.total) {
                    numConfig = sortedConfigs[i];
                    break;
                  }
                }

                // 只有当找到配置且购买数量达到该配置的数量时，才设置gift_config_num_id
                if (numConfig && this.total >= numConfig.num) {
                  giftConfigNumId = numConfig.id;
                }
              }
            }
          }
        }
      }

      // 获取包时套餐折扣ID
      let volumeConfigId = null;
      if (priceType === 0 && this.selectedPackageDuration) {
        if (this.goods_volume_config) {
          const config = this.goods_volume_config.find(config =>
              config.duration_days === this.selectedPackageDuration
          );
          if (config) {
            volumeConfigId = config.id;
          }
        }
      }

      // 获取规格ID
      let skuId = null;
      if (this.goods && this.goods.id) {
        skuId = this.goods.id;
      }

      const params = {
        // 商品ID
        goods_id: this.goodsInfo.id,

        // 规格ID
        sku_id: skuId,

        // 包量套餐赠送配置ID
        gift_config_id: giftConfigId,

        // 包量套餐赠送数量配置ID
        gift_config_num_id: giftConfigNumId,

        // 包时套餐折扣ID
        volume_config_id: volumeConfigId,

        // 购买IP数量
        ip_count: this.total,

        // 支付方式
        pay_type: this.payType, // balance: 余额, alipay: 支付宝, wechat: 微信
      };


      return params;
    },

    // 显示微信支付弹窗
    showWechatPayDialog(payData) {
      // 获取二维码数据，支持多种字段名和base64格式
      let qrCodeData = payData.wechat_data || payData.qr_code || payData.qrcode || payData.qrCode || ''

      // 如果是base64格式，需要添加data:image前缀
      if (qrCodeData && !qrCodeData.startsWith('data:image') && !qrCodeData.startsWith('http')) {
        // 假设返回的是纯base64数据，添加图片前缀
        qrCodeData = `data:image/png;base64,${qrCodeData}`
      }

      // 设置微信支付弹窗数据
      this.wechatPayData = payData;
      this.wechatQrCode = qrCodeData;
      this.showWechatDialog = true;
    },

    // 显示支付宝支付弹窗
    showAlipayPayDialog(payData) {

      // 设置支付宝支付弹窗数据
      this.alipayPayData = payData;
      this.showAlipayDialog = true;
    },

    // 支付宝支付弹窗按钮处理方法
    goToAlipayPay() {
      this.redirectToAlipay(this.alipayPayData);
    },


    goPayStatus() {
      this.$router.push({
        path: '/pay-status',
        query: {order_sn: this.order_sn, type: 'orderpay'}
      });
    },


    // 跳转到支付宝支付
    redirectToAlipay(payData) {
      if (payData.alipay_data) {
        // 如果有HTML内容，打开新窗口
        const newWindow = window.open()
        newWindow.document.write(payData.alipay_data)
        newWindow.document.close()
      } else if (payData.redirect_url) {
        // 如果有重定向URL，直接跳转
        window.location.href = payData.redirect_url
      } else {
        this.$message.error('支付宝支付链接获取失败')
      }
    },

    // 计算总价格
    calculateTotalPrice() {
      if (!this.currentProduct) return 0;

      const priceType = this.getCurrentGoodsPriceType();
      const skuInfo = this.getSelectedSkuInfo();

      if (!skuInfo) return 0;

      if (priceType === 1) {
        // 包量套餐：单价 × 数量
        return (skuInfo.price * this.totalIpCount).toFixed(2);
      } else {
        // 包时套餐：单价 × 每日限制 × 天数
        return (skuInfo.price * this.dailyIpLimit * this.selectedPackageDuration).toFixed(2);
      }
    },

    // 获取选中的SKU信息
    getSelectedSkuInfo() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods || !goods.sku) return null;

      if (this.selectedBillingMethod === 'time_based') {
        // 包时套餐：根据IP时效和套餐时效查找SKU
        return goods.sku.find(sku =>
            sku.validity_minutes === this.selectedIpValidity &&
            sku.duration_days === this.selectedPackageDuration
        );
      } else if (this.selectedBillingMethod === 'volume_based') {
        // 包量套餐：根据IP时效查找SKU
        return goods.sku.find(sku => sku.validity_minutes === this.selectedIpValidity);
      }

      return null;
    },


    // 根据当前IP时效和数量计算赠送百分比
    calculateBonusPercentage(quantity) {
      const priceType = this.goodsInfo.price_type;

      if (priceType === 1 && this.selectedIpValidity && quantity > 0) {
        const currentPackage = this.getCurrentVolumePackage();

        if (currentPackage && currentPackage.goods_gift_config_num) {
          // 找到最接近的数量选项
          const options = currentPackage.goods_gift_config_num.sort((a, b) => a.num - b.num);

          // 如果数量小于最小选项，不赠送
          if (quantity < options[0].num) {
            return 0;
          }

          // 如果数量大于最大选项，返回最大选项的赠送百分比
          if (quantity > options[options.length - 1].num) {
            const maxBonus = parseFloat(options[options.length - 1].gift);
            return maxBonus;
          }

          // 找到合适的数量区间（从大到小查找，找到第一个小于等于当前数量的配置）
          for (let i = options.length - 1; i >= 0; i--) {
            if (quantity >= options[i].num) {
              const bonus = parseFloat(options[i].gift);
              return bonus;
            }
          }

          // 如果没找到，不赠送
          return 0;
        }
      }
      return 0;
    },

    // 根据当前选择计算赠送数量
    calculateBonusForCurrentSelection() {
      const priceType = this.goodsInfo.price_type;
      if (priceType === 1 && this.selectedIpValidity && this.totalIpCount) {
        const bonusPercentage = this.calculateBonusPercentage(this.totalIpCount);
        const bonusMultiplier = 1 + (bonusPercentage / 100);
        this.actualIpCount = Math.floor(this.totalIpCount * bonusMultiplier);
      }
    },

    // 设置默认的每日提取上限
    setDefaultDailyLimit() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods || goods.price_type !== 0) return; // 只有包时套餐才设置每日提取上限

      if (this.selectedIpValidity && this.selectedPackageDuration) {
        if (goods.sku) {
          const sku = goods.sku.find(sku =>
              sku.validity_minutes === this.selectedIpValidity &&
              sku.duration_days === this.selectedPackageDuration
          );
          if (sku && sku.limitation_ip) {
            this.dailyIpLimit = sku.limitation_ip;
          }
        }
      }
    },

    // 设置默认的IP数量
    setDefaultIpCount() {
      const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
      if (!goods || goods.price_type !== 1) return; // 只有包量套餐才设置IP数量

      if (this.selectedIpValidity) {
        if (goods.sku) {
          const sku = goods.sku.find(sku => sku.validity_minutes === this.selectedIpValidity);
          if (sku && sku.limitation_ip) {
            this.totalIpCount = sku.limitation_ip;
          }
        }
      }
    },

    // 更新选中的套餐
    updateSelectedPackage() {
      const priceType = this.getCurrentGoodsPriceType();
      if (priceType === 1) {
        // 包量套餐：根据IP时效选择对应的套餐
        const selectedItem = this.currentProduct.volume_based.find(item =>
            item.validity_minutes == this.selectedIpValidity
        );
        if (selectedItem) {
          this.selectedPackage = selectedItem;
        }
      } else if (priceType === 0) {
        // 包时套餐：根据选中的SKU更新套餐信息
        const selectedSku = this.getSelectedSku();
        if (selectedSku) {
          this.selectedPackage = selectedSku;
        }
      }
    },

    // 计算原价
    calculateOriginalPrice() {
      const priceType = this.goodsInfo.price_type

      // 检查是否有选中的规格
      if (!this.goods || !this.goods.id) {
        return '0.00';
      }

      if (priceType === 1) {
        // 包量套餐：基于当前选中的规格计算价格
        const specPrice = parseFloat(this.goods.price || 0); // 商品规格默认价格
        const ipPrice = parseFloat(this.goods.ip_price || 0); // 每个IP的价格
        const defaultIpCount = this.goods.limitation_ip || 0; // 默认包含的IP数量
        const extraIpCount = Math.max(0, this.totalIpCount - defaultIpCount); // 超出默认数量的IP数量

        // 总价格 = 规格默认价格 + 超出数量的额外费用
        const extraPrice = extraIpCount * ipPrice;
        const totalPrice = specPrice + extraPrice;
        return totalPrice.toFixed(2);
      } else if (priceType === 0) {
        // 包时套餐：基于当前选中的规格计算价格
        const specPrice = parseFloat(this.goods.price || 0); // 商品规格默认价格
        const ipPrice = parseFloat(this.goods.ip_price || 0); // 每个IP的价格
        const defaultIpCount = this.goods.limitation_ip || 0; // 默认包含的IP数量
        const extraIpCount = Math.max(0, this.dailyIpLimit - defaultIpCount); // 超出默认数量的IP数量

        // 总价格 = 规格默认价格 + 超出数量的额外费用
        const extraPrice = extraIpCount * ipPrice;
        const totalPrice = specPrice + extraPrice;
        return totalPrice.toFixed(2);
      }

      return '0.00';
    },

    // 计算最终价格
    calculateFinalPrice() {

      const priceType = this.goodsInfo.price_type


      if (priceType === 1) {
        // 包量套餐：直接返回原价
        return this.calculateOriginalPrice();
      } else if (priceType === 0) {
        // 包时套餐：根据选中的SKU和折扣计算价格
        const originalPrice = parseFloat(this.calculateOriginalPrice());
        if (this.shouldApplyDiscount) {
          const discountPercentage = this.currentDiscountPercentage;
          const discountMultiplier = 1 - (discountPercentage / 100);
          return (originalPrice * discountMultiplier).toFixed(2);
        } else {
          return originalPrice.toFixed(2);
        }
      }
      return '0.00';
    },

    // 实时计算价格（当规格或数量变化时调用）
    calculatePrice() {
      // 检查是否有选中的规格
      if (!this.goods) {
        return '0.00';
      }

      const specPrice = parseFloat(this.goods.price || 0);
      const ipPrice = parseFloat(this.goods.ip_price || 0);
      const defaultIpCount = this.goods.limitation_ip || 0;

      // 无论是包量套餐还是包时套餐，都使用total计算
      const extraIpCount = Math.max(0, this.total - defaultIpCount);
      const extraPrice = extraIpCount * ipPrice;
      let totalPrice = specPrice + extraPrice;

      // 如果是包时套餐且有折扣，在总价格基础上进行打折
      if (this.goodsInfo.price_type === 0 && this.shouldApplyDiscount) {
        const discountPercentage = this.currentDiscountPercentage;
        const discountMultiplier = 1 - (discountPercentage / 100);
        totalPrice = totalPrice * discountMultiplier;
      }

      return totalPrice.toFixed(2);
    },

    // 计算额外赠送的IP数量（在购买数量的基础上额外赠送）
    calculateBonusIpCount() {
      if (this.goodsInfo.price_type !== 1 || !this.selectedIpValidity || !this.totalIpCount) {
        return 0;
      }

      // 根据当前IP时效和购买数量计算赠送百分比
      const bonusPercentage = this.calculateBonusPercentage(this.total);
      if (bonusPercentage <= 0) {
        return 0;
      }

      // 计算额外赠送的数量（基于购买数量计算）
      const bonusCount = Math.floor(this.total * (bonusPercentage / 100));

      return bonusCount;
    },

    // 计算最终获得的IP数量（购买数量 + 额外赠送数量）
    calculateTotalIpCount() {
      if (this.goodsInfo.price_type !== 1 || !this.selectedIpValidity || !this.total) {
        return this.total || 0;
      }

      const bonusCount = this.calculateBonusIpCount();
      const totalCount = this.total + bonusCount;

      return totalCount;
    },

    // 计算折扣文字
    calculateDiscountText(discountPercentage) {
      const discount = parseFloat(discountPercentage);
      if (discount >= 100) {
        return '免费';
      } else if (discount >= 90) {
        return '1折';
      } else if (discount >= 80) {
        return '2折';
      } else if (discount >= 70) {
        return '3折';
      } else if (discount >= 60) {
        return '4折';
      } else if (discount >= 50) {
        return '5折';
      } else if (discount >= 40) {
        return '6折';
      } else if (discount >= 30) {
        return '7折';
      } else if (discount >= 20) {
        return '8折';
      } else if (discount >= 10) {
        return '9折';
      } else {
        return '原价';
      }
    },

    // 获取默认描述
    getDefaultDescription(serviceType) {
      if (serviceType === 'volume_based') {
        return '适用于短期或不定期高提取的业务场景';
      } else if (serviceType === 'time_based') {
        return '适用于每日提取量稳定的业务场景';
      }
      return '';
    },

    // 获取当前选中的SKU
    getSelectedSku() {
      if (this.selectedBillingMethod === 'time_based' && this.currentProduct) {
        // 找到对应的商品
        const goods = this.goodsList.find(item => item.id === this.currentProduct.id);
        if (goods && goods.sku) {
          // 根据IP时效和套餐时效找到对应的SKU
          return goods.sku.find(sku =>
              sku.validity_minutes === this.selectedIpValidity &&
              sku.duration_days === this.selectedPackageDuration
          );
        }
      }
      return null;
    },

    // 获取当前选中的包量套餐信息
    getCurrentVolumePackage() {
      const priceType = this.goodsInfo.price_type;

      if (priceType === 1 && this.goods_gift_config_num) {
        const volumePackage = this.goods_gift_config_num.find(item =>
            item.validity_minutes == this.selectedIpValidity
        );

        return volumePackage;
      }
      return null;
    },

    // 获取指定时效的数量选项
    getQuantityOptions(validityMinutes) {
      // 从 volumeBasedPackages 中查找对应的套餐
      const packageItem = this.volumeBasedPackages.find(item =>
          item.validity_minutes == validityMinutes
      );
      const options = packageItem ? packageItem.quantity_options : [];
      return options;
    },

    // 获取支付方式数字
    getPayTypeNumber() {
      switch (this.payType) {
        case 'alipay':
          return 1;
        case 'wechat':
          return 2;
        case 'balance':
          return 3;
        default:
          return 3; // 默认余额支付
      }
    },


    // 获取当前应该展开的面板索引
    getActivePanelIndex() {
      const priceType = this.getCurrentGoodsPriceType();
      if (priceType === 1 && this.selectedIpValidity) {
        const index = this.volumeBasedPackages.findIndex(item =>
            item.validity_minutes == this.selectedIpValidity
        );
        return index >= 0 ? index + 1 : null;
      }
      return null;
    },

    // 获取当前数量区间信息
    getCurrentQuantityRange() {
      const priceType = this.getCurrentGoodsPriceType();
      if (priceType === 1 && this.selectedIpValidity) {
        const currentPackage = this.getCurrentVolumePackage();
        if (currentPackage && currentPackage.quantity_options) {
          const options = currentPackage.quantity_options.sort((a, b) => a.quantity - b.quantity);

          for (let i = 0; i < options.length; i++) {
            if (this.totalIpCount >= options[i].quantity) {
              if (i < options.length - 1) {
                return {
                  current: options[i],
                  next: options[i + 1],
                  bonusPercentage: parseFloat(options[i + 1].bonus_percentage)
                };
              } else {
                return {
                  current: options[i],
                  next: null,
                  bonusPercentage: parseFloat(options[i].bonus_percentage)
                };
              }
            }
          }
        }
      }
      return null;
    },

    // 当规格选择变化时，自动更新包量套餐的选择
    updateVolumePackageSelection() {
      // 只有在包量套餐时才执行自动更新
      if (this.goodsInfo.price_type != 1) {
        return;
      }

      // 检查是否所有规格都已选择
      if (this.goods_sku_ids.length === this.skuSpec.length &&
          this.goods_sku_ids.every(id => id !== '' && id !== undefined)) {

        // 根据选中的规格找到对应的SKU
        const selectedSkuIds = [...this.goods_sku_ids].sort((a, b) => a - b)
        const skuKey = selectedSkuIds.join(',')

        if (this.sku && this.sku[skuKey]) {
          const selectedSku = this.sku[skuKey]

          // 更新IP时效
          if (selectedSku.validity_minutes) {
            this.selectedIpValidity = selectedSku.validity_minutes
          }

          // 更新IP数量为规格的默认值
          if (selectedSku.limitation_ip) {
            this.total = selectedSku.limitation_ip
            this.totalIpCount = selectedSku.limitation_ip
          }

          // 更新赠送信息
          this.updateGiftInfo(selectedSku)
        }
      }
    },

    // 当规格选择变化时，自动更新包时套餐的选择
    updateTimePackageSelection() {
      // 只有在包时套餐时才执行自动更新
      if (this.goodsInfo.price_type != 0) {
        return;
      }

      // 检查是否所有规格都已选择
      if (this.goods_sku_ids.length === this.skuSpec.length &&
          this.goods_sku_ids.every(id => id !== '' && id !== undefined)) {

        // 根据选中的规格找到对应的SKU
        const selectedSkuIds = [...this.goods_sku_ids].sort((a, b) => a - b)
        const skuKey = selectedSkuIds.join(',')

        if (this.sku && this.sku[skuKey]) {
          const selectedSku = this.sku[skuKey]

          // 更新IP时效
          if (selectedSku.validity_minutes) {
            this.selectedIpValidity = selectedSku.validity_minutes
          }

          // 更新套餐时效
          if (selectedSku.duration_days) {
            this.selectedPackageDuration = selectedSku.duration_days
          }

          // 更新每日提取上限
          if (selectedSku.limitation_ip) {
            this.dailyIpLimit = selectedSku.limitation_ip
            this.total = selectedSku.limitation_ip
          }

          // 更新折扣信息
          this.updateVolumeConfig(selectedSku)
        }
      }
    },

    // 更新赠送信息
    updateGiftInfo(selectedSku) {
      // 只有在包量套餐时才更新赠送信息
      if (this.goodsInfo.price_type != 1) {
        return;
      }

      if (this.goods_gift_config_num && this.goods_gift_config_num.length > 0) {
        // 找到对应IP时效的赠送配置
        const giftConfig = this.goods_gift_config_num.find(config =>
            config.validity_minutes === selectedSku.validity_minutes
        )

        if (giftConfig && giftConfig.goods_gift_config_num) {
          // 找到对应数量的配置
          const numConfig = giftConfig.goods_gift_config_num.find(num =>
              num.num === selectedSku.limitation_ip
          )

          if (numConfig) {
            this.giftInfo.minute_id = giftConfig.id
            this.giftInfo.num_id = numConfig.id
          }
        }
      }
    },

    // 更新折扣信息
    updateVolumeConfig(selectedSku) {
      // 只有在包时套餐时才更新折扣信息
      if (this.goodsInfo.price_type != 0) {
        return;
      }

      if (this.goods_volume_config && this.goods_volume_config.length > 0) {
        // 找到对应套餐时效的折扣配置
        const volumeConfig = this.goods_volume_config.find(config =>
            config.duration_days === selectedSku.duration_days
        )

        if (volumeConfig) {
          this.volume_id = volumeConfig.id
        }
      }
    },

    // 初始化默认的包量套餐选择
    initDefaultVolumePackageSelection() {
      // 只有在包量套餐时才初始化默认选择
      if (this.goodsInfo.price_type != 1) {
        return;
      }

      // 如果有包量套餐配置，设置默认选择
      if (this.goods_gift_config_num && this.goods_gift_config_num.length > 0) {
        const firstGiftConfig = this.goods_gift_config_num[0]

        if (firstGiftConfig.goods_gift_config_num && firstGiftConfig.goods_gift_config_num.length > 0) {
          const firstNumConfig = firstGiftConfig.goods_gift_config_num[0]

          // 设置默认的IP时效
          this.selectedIpValidity = firstGiftConfig.validity_minutes

          // 设置默认的IP数量
          this.total = firstNumConfig.num
          this.totalIpCount = firstNumConfig.num

          // 设置默认的赠送信息
          this.giftInfo.minute_id = firstGiftConfig.id
          this.giftInfo.num_id = firstNumConfig.id

          // 自动选择对应的规格
          this.autoSelectSkuByValidity(firstGiftConfig.validity_minutes)
        }
      }
    },

    // 初始化默认的包时套餐选择
    initDefaultTimePackageSelection() {
      // 只有在包时套餐时才初始化默认选择
      if (this.goodsInfo.price_type != 0) {
        return;
      }

      // 如果有包时套餐配置，设置默认选择
      if (this.goods_volume_config && this.goods_volume_config.length > 0) {
        const firstVolumeConfig = this.goods_volume_config[0]

        // 设置默认的套餐时效
        this.selectedPackageDuration = firstVolumeConfig.duration_days

        // 自动选择对应的规格
        this.autoSelectSkuByDuration(firstVolumeConfig.duration_days)
      }
    },

    // 根据IP时效自动选择对应的规格
    autoSelectSkuByValidity(validityMinutes) {
      // 只有在包量套餐时才自动选择规格
      if (this.goodsInfo.price_type != 1) {
        return;
      }

      if (this.goodsInfo.sku && this.skuSpec) {
        // 找到对应IP时效的SKU
        const targetSku = this.goodsInfo.sku.find(sku =>
            sku.validity_minutes === validityMinutes
        )

        if (targetSku) {
          // 解析SKU ID并设置对应的规格选择
          const skuIdArray = targetSku.sku_id.split(',').map(id => parseInt(id.trim()))

          this.skuSpec.forEach((spec, specIndex) => {
            spec.sku_value.forEach((value) => {
              if (skuIdArray.includes(value.id)) {
                this.$set(this.goods_sku_ids, specIndex, value.id)
                this.$set(this.goods_sku_text, specIndex, value.title)
              }
            })
          })
        }
      }
    },

    // 根据套餐时效自动选择对应的规格
    autoSelectSkuByDuration(durationDays) {
      // 只有在包时套餐时才自动选择规格
      if (this.goodsInfo.price_type != 0) {
        return;
      }

      if (this.goodsInfo.sku && this.skuSpec) {
        // 找到对应套餐时效的SKU
        const targetSku = this.goodsInfo.sku.find(sku =>
            sku.duration_days === durationDays
        )

        if (targetSku) {
          // 解析SKU ID并设置对应的规格选择
          const skuIdArray = targetSku.sku_id.split(',').map(id => parseInt(id.trim()))

          this.skuSpec.forEach((spec, specIndex) => {
            spec.sku_value.forEach((value) => {
              if (skuIdArray.includes(value.id)) {
                this.$set(this.goods_sku_ids, specIndex, value.id)
                this.$set(this.goods_sku_text, specIndex, value.title)
              }
            })
          })

          // 设置IP时效
          if (targetSku.validity_minutes) {
            this.selectedIpValidity = targetSku.validity_minutes
          }

          // 设置每日提取上限
          if (targetSku.limitation_ip) {
            this.dailyIpLimit = targetSku.limitation_ip
            this.total = targetSku.limitation_ip
          }
        }
      }
    },

    // 初始化规格选择
    initSkuSelection() {
      // 清空所有规格选择
      this.goods_sku_ids = []
      this.goods_sku_text = []

      // 重置相关数据
      this.total = 0
      this.totalIpCount = 0
      this.dailyIpLimit = 0
      this.selectedIpValidity = null
      this.selectedPackageDuration = null

      // 重置赠送和折扣信息
      this.giftInfo = {
        minute_id: 0,
        num_id: 0,
      }
      this.volume_id = 0

      // 重置实际IP数量
      this.actualIpCount = 0
    },


  }
}
</script>

<style scoped>
.main {
  margin: auto 0;
  background-color: #f7f8fa;
  margin-top: 80px;
  width: 100%;
  overflow-x: hidden;
}

.home-banner {
  width: auto;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 300px;
}

.agent .box {
  margin: 0 auto;
  width: 1600px;
  max-width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}

.tab .item {
  width: 168px;
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  text-align: center;
  border-radius: 4px;
}

.tab .active {
  color: #fff;
  background: #2682ff;
}


.combo {
  padding-right: 50px;
  width: 196px;
  min-width: 196px;
  display: flex;
  flex-wrap: wrap;
}

.combo h3 {
  width: 100%;
  display: block;
  font-size: 16px;
}

.combo h3:nth-of-type(2) {
  padding-top: 10px;
  border-top: 1px solid #ccc;
}

.collapse {
  margin-top: 20px;
  width: 100%;
  border: 0;
}

.custom-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.toggle-text {
  transition: transform 0.3s ease;
  color: #606266;
}

::v-deep .el-collapse-item__arrow {
  display: none;
}

::v-deep .el-collapse-item__wrap {
  border: 0;
}

::v-deep .el-collapse-item .el-collapse-item__header {
  height: 30px;
  line-height: 30px;
  border-bottom: 0;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}

.collapse dl {
  height: 36px;
  line-height: 36px;
  font-size: 12px;
}

.quantity-item {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
  padding: 0 5px;
}

.quantity-item:hover {
  background: #f0f8ff;
}

.quantity-item.active {
  background: #e9efff;
}


.collapse dl dd {
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  color: #f27729;
  font-size: 12px;
  background: #fde4dd;
  border-radius: 4px;
}

.ip-effect {
  display: flex;
  margin-bottom: 20px;
}

.ip-effect button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 4px;
}

.ip-effect button.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.purchase {
  padding: 0 50px;
  width: 900px;
  flex: 1;
  min-width: 0;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
}

.purchase h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: normal;
}

.charge {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
}

.charge-item {
  margin-right: 24px;
  margin-bottom: 10px;
  padding: 20px;
  color: #143b72;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
}

.charge-item:hover {
  border-color: #2780fe;
}

.charge-item.active {
  color: #2780fe;
  border: 1px solid #2780fe;
}

.charge-item h4 {
  margin: 0;
  font-size: 16px;
  font-weight: normal;
}

.charge-item .description {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #46678a;
  font-weight: normal;
}

.charge h4 {
  font-size: 16px;
  font-weight: normal;
}

.package-duration {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
}

.package-item {
  margin-right: 24px;
  margin-bottom: 10px;
  padding: 20px;
  color: #143b72;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  min-width: 120px;
}

.package-item:hover {
  border-color: #2780fe;
}

.package-item.active {
  color: #2780fe;
  border: 1px solid #2780fe;
}

.package-item.active .discount {
  color: #2780fe;
}

.package-item h4 {
  margin: 0;
  font-size: 16px;
  font-weight: normal;
}

.package-item .discount {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #f3753b;
  font-weight: normal;
}

.charge span {
  padding: 2px 10px;
  color: #143b72;
  font-size: 12px;
  border-radius: 2px;
  background: #fbf0ea;
}

.charge p {
  color: #46678a;
  font-size: 14px;
}

.aging {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
}

.aging-item {
  margin-right: 24px;
  margin-bottom: 10px;
  padding: 20px;
  color: #143b72;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  min-width: 100px;
}

.aging-item:hover {
  border-color: #2780fe;
}

.aging-item.active {
  color: #2780fe;
  border: 1px solid #2780fe;
}

.aging-item.active .price {
  color: #2780fe;
}

.charge-item.active .description {
  color: #2780fe;
}

.aging-item h4 {
  margin: 0;
  font-size: 16px;
  font-weight: normal;
}

.aging-item .price {
  margin: 5px 0 0 0;
  font-size: 12px;
  color: #143b72;
  font-weight: normal;
}

.total {
  margin-top: 20px;
}

.total ::v-deep .el-input-number {
  width: 200px;
}

.total ::v-deep .el-checkbox__label {
  color: #214a88;
}

.total em {
  color: #f3753b;
  font-weight: normal;
}


.bonus-text em {
  color: #f27729;
  font-weight: bold;
  font-style: normal;
}


.actual-count em {
  color: #f27729;
  font-weight: bold;
  font-style: normal;
}

.bonus-tag {
  padding: 2px 8px;
  height: 20px;
  line-height: 20px;
  color: #f27729;
  font-size: 12px;
  background: #fde4dd;
  border-radius: 4px;
}


.total em {
  color: #f3753b;
}


.product-features li {
  width: 34%;
  height: 40px;
  line-height: 40px;
  color: #183e7c;
  font-size: 14px;
}

.product-features .el-icon-check {
  margin-right: 10px;
  color: #1f7eff;
  font-weight: normal;
}

.order {
  margin-left: 50px;
  /* padding: 0 50px; */
  width: 400px;
  min-width: 350px;
  flex-shrink: 0;
}

.order h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: normal;
}

.order dl {
  height: 50px;
  line-height: 50px;
  color: #143b72;
  font-size: 14px;
}

.order dl dt {
  font-weight: normal;
}

.pay {
  border-top: 1px solid #eee;
}

.pay dt {
  color: #f3753b;
  font-size: 20px;
}

.payment {
  margin-top: 20px;
  display: flex;
  gap: 8px;
  /* 减少选项之间的间距 */
  width: 100%;
}

.payment-item {
  flex: 1;
  /* 让每个选项平均分配宽度 */
  box-sizing: border-box;
  padding: 12px 16px;
  /* 增加内边距 */
  display: flex;
  justify-content: center;
  align-items: center;
  /* 垂直居中 */
  border: 1px solid #ddd;
  /* 确保边框显示 */
  min-height: 44px;
  /* 设置最小高度确保一致性 */
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  background: #fff;
  position: relative;
}

.payment-item:hover {
  border-color: #2682ff;
  background: #f8f9fa;
}

.payment-item.active {
  color: #1a336b;
  background: #e9efff;
  border: 1px solid #2682ff;
  /* 选中状态的边框 */
}

.payment-item.active .pay-type {
  color: #1a336b;
}

.pay-type {
  color: #1a336b;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
}

.pay-type img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  flex-shrink: 0;
  /* 防止图标被压缩 */
  object-fit: contain;
  display: block;
}

.alipay-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background: #1677ff;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}


.qr-code-loading i {
  font-size: 24px;
  margin-bottom: 10px;
}

.qr-code-loading p {
  margin: 0;
  font-size: 14px;
}

/* .pay-type img{
      width: 24px;
      height: 24px;
  } */
.payment-options button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 4px;
}

.pay-btn {
  width: 100%;
  color: #fff;
  background: #007bff;
}


.ip p {
  /* width: 20%; */
  color: #183e7c;
  font-size: 14px;
}

.ip p::before {
  margin-right: 10px;
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: #1ae206;
}

.list .item {
  position: relative;
  margin: 0 40px 40px 0;
  padding: 40px;
  width: calc(25% - 30px);
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #fff;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.list .item:hover {
  border: 1px solid #2682ff;
}

.list .name {
  width: 100%;
  color: #2682ff;
  font-size: 20px;
  text-align: center;
}


.list .item:nth-of-type(4n) {
  margin-right: 0;
}

.list ul {
  margin-top: 56px;
}

.list li {
  height: 36px;
  line-height: 36px;
  color: #999;
  font-size: 14px;
}


/* 特性区域 */
.features {
  padding: 100px 0;
  text-align: center;
  background: #edf2f8;
}

@media screen and (max-width: 768px) {
  .features {
    padding: 50px 0;
  }

  .features-box {
    width: 95%;
    padding: 20px;
  }
}

@media screen and (max-width: 480px) {
  .features-box {
    width: 98%;
    padding: 15px;
  }
}


.features h2 {
  font-size: 24px;
}

.features p {
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}

.feature-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.feature-card {
  margin-right: 10px;
  padding: 20px;
  flex: 0 0 calc(33.33% - 20px);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .feature-card {
    flex: 0 0 calc(50% - 10px);
    margin-right: 10px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 480px) {
  .feature-card {
    flex: 0 0 100%;
    margin-right: 0;
  }
}

.feature-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.feature-card h3 {
  font-size: 18px;
}

.feature-card p {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}

.customize p {
  line-height: 36px;
  color: #183e7c;
  font-size: 18px
}

@media screen and (max-width: 768px) {
  .customize-container {
    flex-direction: column;
  }

  .customize-image {
    width: 100%;
    max-width: 300px;
    margin: 0 auto 20px;
  }

  .customize {
    margin-left: 0 !important;
  }

  .customize p {
    font-size: 16px;
    line-height: 28px;
  }

  .customize ul {
    flex-wrap: wrap;
  }

  .customize ul li {
    margin-right: 15px;
    margin-bottom: 10px;
  }
}

/* 响应式设计 */
@media screen and (max-width: 1600px) {
  .agent .box {
    width: 95%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 1200px) {
  .tab-contnt {
    flex-direction: column;
  }

  .combo {
    width: 100%;
    min-width: auto;
    padding-right: 0;
    margin-bottom: 30px;
  }

  .purchase {
    width: 100%;
    padding: 0;
    border-left: none;
    border-right: none;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }

  .order {
    width: 100%;
    min-width: auto;
    margin-left: 0;
  }

  .agent .box {
    width: 98%;
    padding: 15px;
  }
}

@media screen and (max-width: 768px) {
  .agent .box {
    width: 100%;
    padding: 10px;
    margin-top: 10px;
  }

  .tab .item {
    width: 120px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
  }

  .combo {
    padding: 0 10px;
  }

  .purchase {
    padding: 20px 10px;
  }

  .order {
    padding: 0 10px;
  }

  .charge-item {
    margin-right: 15px;
    margin-bottom: 15px;
    padding: 15px;
  }

  .aging-item {
    margin-right: 15px;
    margin-bottom: 15px;
    padding: 15px;
    min-width: 80px;
  }

  .payment {
    flex-direction: column;
    gap: 10px;
  }

  .payment-item {
    width: 100%;
  }

  .product-features li {
    width: 100%;
  }

  /* 优化订单详情在小屏幕上的显示 */
  .order dl {
    height: auto;
    min-height: 50px;
    line-height: 1.5;
    padding: 8px 0;
    flex-wrap: wrap;
  }

  .order dl dd,
  .order dl dt {
    width: 100%;
    text-align: left;
    padding: 2px 0;
  }

  .order dl dd {
    order: 1;
  }

  .order dl dt {
    order: 2;
    font-weight: bold;
  }
}

@media screen and (max-width: 480px) {
  .agent .box {
    padding: 5px;
  }

  .tab .item {
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
  }

  .combo {
    padding: 0 5px;
  }

  .purchase {
    padding: 15px 5px;
  }

  .order {
    padding: 0 5px;
  }

  .charge-item {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
  }

  .aging-item {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 10px;
    min-width: 70px;
  }

  .total ::v-deep .el-input-number {
    width: 100%;
  }

  .pay-btn {
    height: 44px;
    font-size: 16px;
  }

  /* 确保订单详情在小屏幕上完全可见 */
  .order {
    overflow: visible;
  }

  .order dl {
    word-break: break-word;
  }

  .order dl dt {
    word-break: break-all;
  }
}

@media screen and (max-width: 360px) {
  .agent .box {
    padding: 3px;
  }

  .tab .item {
    width: 80px;
    height: 35px;
    line-height: 35px;
    font-size: 11px;
  }

  .combo {
    padding: 0 3px;
  }

  .purchase {
    padding: 10px 3px;
  }

  .order {
    padding: 0 3px;
  }

  .charge-item {
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 8px;
  }

  .aging-item {
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 8px;
    min-width: 60px;
  }

  .payment-item {
    padding: 8px 12px;
    min-height: 40px;
  }

  .pay-type {
    font-size: 12px;
  }

  .pay-type img {
    width: 16px;
    height: 16px;
  }

  .alipay-icon {
    width: 16px;
    height: 16px;
    font-size: 10px;
  }
}
</style>
